import { Grid, Typography } from '@mui/material'
import { RenewChannelOfferResellerAuthorization } from '../../../RenewChannelOfferSubscription/renewChannelOfferTypes'
import {
  EntitlementSubs,
  Subscription,
} from '../../../../../modules/subscription/reducer'
import { useStyles } from '../SubscriptionEntitlement.styles'
import { TableComponentV2 } from '@labrav/react-components'
import { isNonEmptyNumber } from '@labrav/common'
import { PriceTypes } from '../../../../../types/flyout'
import { get, isNull, isUndefined } from 'lodash'
import { ContractDurationType, DiscountType } from '../../../../../types/flyout'
import {
  getResalePriceKeyCamelizeConversion,
  getMappedMonthKey,
} from '../../../../../utils/resalePriceHelpers'

export const SubscriptionCPPOEntitlement = (props: {
  flexiblePayment: boolean
  entitlements: EntitlementSubs[]
  subscription: Subscription
  receivedResaleAuthorization?: RenewChannelOfferResellerAuthorization
}) => {
  const { classes } = useStyles()

  const { flexiblePayment, entitlements, receivedResaleAuthorization } = props

  const receivedResaleAuthorizationDimensions =
    receivedResaleAuthorization?.dimensions

  const additionalUsageEntitlements = entitlements?.filter(
    item => !!item?.isAdditionalUsageAllowed
  )
  const standardEntitlements = entitlements?.filter(
    item => !item?.isAdditionalUsageAllowed
  )

  const standardEntitlementsMapping = {
    Dimensions: 'dimensionLabel',
    'Wholesale price': 'wholesalePrice',
    ...(flexiblePayment
      ? { Quantity: 'quantity' }
      : { 'Buyer unit price': 'price', Margin: 'margin' }),
  }

  const additionalUsageEntitlementsMapping = {
    Dimensions: 'dimensionLabel',
    [`Wholesale ${getMappedMonthKey(
      getResalePriceKeyCamelizeConversion(standardEntitlements[0]?.activePrice)
    )} price`]: 'wholesalePrice',
    'Buyer unit price': 'price',
    Margin: 'margin',
  }

  const isFlexiblePricingResaleAuth =
    receivedResaleAuthorization?.discountType ===
    DiscountType.FLEXIBLE_PAYMENT_TERMS

  const customContractDuration =
    receivedResaleAuthorization?.contractDurationType ===
    ContractDurationType.CUSTOM

  const additionalUsageEntitlementObject = additionalUsageEntitlements.map(
    entitlementDetailItem => {
      const resaleAuthDimension = receivedResaleAuthorizationDimensions?.find(
        item =>
          item?.name === entitlementDetailItem?.dimensionName &&
          item?.isAdditionalUsageAllowed ===
            entitlementDetailItem?.isAdditionalUsageAllowed
      )

      const margin =
        isNonEmptyNumber(entitlementDetailItem?.price) &&
        !isNull(
          (resaleAuthDimension?.prices as PriceTypes)?.additionalUsagePrice
        ) &&
        !isUndefined(
          (resaleAuthDimension?.prices as PriceTypes)?.additionalUsagePrice
        )
          ? entitlementDetailItem?.price -
            ((resaleAuthDimension?.prices as PriceTypes)
              ?.additionalUsagePrice || 0)
          : '-'
      return {
        dimensionLabel: (
          <DimensionLabelValue label={entitlementDetailItem?.dimensionLabel} />
        ),
        dimensionDescription: (
          <DimensionLabelValue
            label={entitlementDetailItem?.labelDescription}
          />
        ),
        wholesalePrice: (
          <DimensionLabelValue
            label={
              !isNull(
                (resaleAuthDimension?.prices as PriceTypes)
                  ?.additionalUsagePrice
              ) &&
              !isUndefined(
                (resaleAuthDimension?.prices as PriceTypes)
                  ?.additionalUsagePrice
              )
                ? `$${
                    (resaleAuthDimension?.prices as PriceTypes)
                      ?.additionalUsagePrice
                  }`
                : '-'
            }
          />
        ),
        price: (
          <DimensionLabelValue
            label={
              isNonEmptyNumber(entitlementDetailItem?.price)
                ? `$${entitlementDetailItem?.price}`
                : '-'
            }
          />
        ),
        margin: <DimensionLabelValue label={margin as string} />,
      }
    }
  )

  const standardentitlementObject = standardEntitlements.map(
    entitlementDetailItem => {
      const resaleAuthDimension = receivedResaleAuthorizationDimensions?.find(
        item =>
          item?.name === entitlementDetailItem?.dimensionName &&
          item?.isAdditionalUsageAllowed ===
            entitlementDetailItem?.isAdditionalUsageAllowed
      )

      const wholesalePrice = get(
        isFlexiblePricingResaleAuth || customContractDuration
          ? resaleAuthDimension
          : resaleAuthDimension?.prices,
        getResalePriceKeyCamelizeConversion(entitlementDetailItem?.activePrice),
        undefined
      )

      const buyerPrice = entitlementDetailItem?.price

      const margin =
        isNonEmptyNumber(buyerPrice) && isNonEmptyNumber(wholesalePrice)
          ? buyerPrice - wholesalePrice!
          : '-'
      return {
        dimensionLabel: (
          <DimensionLabelValue label={entitlementDetailItem?.dimensionLabel} />
        ),
        dimensionDescription: (
          <DimensionLabelValue
            label={entitlementDetailItem?.labelDescription}
          />
        ),
        quantity: <DimensionLabelValue label={entitlementDetailItem.value} />,
        wholesalePrice: (
          <DimensionLabelValue
            label={
              isNonEmptyNumber(wholesalePrice) ? `$${wholesalePrice}` : '-'
            }
          />
        ),
        price: (
          <DimensionLabelValue
            label={
              isNonEmptyNumber(entitlementDetailItem?.price)
                ? `$${entitlementDetailItem?.price}`
                : '-'
            }
          />
        ),
        margin: <DimensionLabelValue label={margin as string} />,
      }
    }
  )

  return (
    <div>
      <div className={classes.root}>
        <span className={classes.heading}>Dimensions details</span>
        <div className={classes.firstDiv}>
          <Grid container spacing={0} className={classes.tableGridComponent}>
            <div className={classes.firstInnerDiv}>
              <TableComponentV2
                keyName={'entitlementsData'}
                objects={standardentitlementObject}
                mapping={standardEntitlementsMapping}
                selectedItem={[]}
                onChangeCheckbox={() => void 0}
                showCheckbox={false}
                isBasicTable={true}
                count={0}
                fetchMoreData={() => void 0}
              />
            </div>
          </Grid>
        </div>
      </div>
      {!!additionalUsageEntitlementObject?.length && (
        <div className={classes.root}>
          <span className={classes.heading}>Additional usage</span>
          <div className={classes.firstDiv}>
            <Grid container spacing={0} className={classes.tableGridComponent}>
              <div className={classes.firstInnerDiv}>
                <TableComponentV2
                  keyName={'entitlementsData'}
                  objects={additionalUsageEntitlementObject}
                  mapping={additionalUsageEntitlementsMapping}
                  selectedItem={[]}
                  onChangeCheckbox={() => void 0}
                  showCheckbox={false}
                  isBasicTable={true}
                  count={0}
                  fetchMoreData={() => void 0}
                />
              </div>
            </Grid>
          </div>
        </div>
      )}
    </div>
  )
}

const DimensionLabelValue = ({ label }: { label?: string }) => {
  const { classes } = useStyles()
  return <Typography className={classes.value}>{label || '-'}</Typography>
}
